import React from 'react';
import {
    MDBRow,
    MDBCol,
    MDBTextArea,
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardText,
    MDBBtn,
    MDBIcon,
    MDBBadge,
    MDBInput
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
const FieldGroup = ({ fields, formData, isEdit, handleChange, addItem, removeItem }) => {
    return (
        <>
            {fields.map((field) => (
                <MDBCard key={field}>
                    <MDBCardBody>
                        <MDBRow className='mb-2' key={field}>
                            <MDBCol>
                                <MDBCardHeader>
                                    <h5>{field.charAt(0).toUpperCase() + field.slice(1)}</h5>
                                </MDBCardHeader>
                                {isEdit ? (
                                    <>
                                        <MDBInput
                                            wrapperClass='text-start mb-2'
                                            id={`${field}-value`}
                                            label={`${field.charAt(0).toUpperCase() + field.slice(1)} Value`}
                                            value={formData[`${field}Value`] || ''}
                                            onChange={(e) =>
                                                handleChange(null, null, null, `${field}Value`, e.target.value)
                                            }
                                        />
                                        {formData[field]?.map((item, index) => (
                                            <MDBRow key={`${field}-${index}`} className="mb-2 position-relative">
                                                <MDBTextArea
                                                    wrapperClass='text-start'
                                                    id={`${field}-${index}`}
                                                    label={`${field.charAt(0).toUpperCase() + field.slice(1)} Item ${index + 1}`}
                                                    rows={4}
                                                    value={item}
                                                    onChange={(e) =>
                                                        handleChange(null, null, null, field, [...formData[field].slice(0, index), e.target.value, ...formData[field].slice(index + 1)])
                                                    }
                                                />
                                                <span style={{ position: 'absolute'}} className='top-0 end-0'>
                                                    <MDBBtn
                                                        type='button'
                                                        className='position-absolute translate-middle top-0 end-0'
                                                        tag='a'
                                                        color='none'
                                                        onClick={() => removeItem(field, index)}
                                                    >
                                                        <MDBIcon fas icon="times" />
                                                    </MDBBtn>
                                                </span>
                                            </MDBRow>
                                        ))}
                                        <MDBBtn color="primary" onClick={() => addItem(field)} type='button' className='mt-2'>
                                            Add {field.charAt(0).toUpperCase() + field.slice(1)} Item
                                        </MDBBtn>
                                    </>
                                ) : (
                                    <>
                                        <MDBCardText className='text-start'>{formData[`${field}Value`] || ''}</MDBCardText>
                                        {formData[field]?.map((item, index) => (
                                            <MDBCard key={`${field}-${index}`} className='mb-2'>
                                                <MDBCardBody>
                                                    <MDBCardText className='text-start'>{item}</MDBCardText>
                                                </MDBCardBody>
                                            </MDBCard>
                                        ))}
                                    </>
                                )}
                            </MDBCol>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
            ))}
        </>
    );
};


FieldGroup.propTypes = {
    fields: PropTypes.array,
    formData: PropTypes.object,
    isEdit: PropTypes.bool,
    handleChange: PropTypes.func,
    addItem: PropTypes.func,
    removeItem: PropTypes.func,
  };
  

export default FieldGroup;
